import { RevenueCategory, RevenueSubCategory } from '../types/revenues';
import { categoryTreeService } from './categoryTreeService';

const revenueCategoryService = categoryTreeService<RevenueCategory, RevenueSubCategory>('/revenue-categories');

export default revenueCategoryService;
